import * as React from 'react';

import { CombinedProductionViewProps } from '../../components/list/production';
import ListPerformances from '../../components/list/performances';

const ListMonthsView: React.StatelessComponent<CombinedProductionViewProps> = props => {

    const pdpHeader = (
        <h3 id={`Prod-Group-${props.production.productionTitle}`} className="h1-secondary">{props.production.productionTitle}</h3>
    );

    return (
        <li className="">
            <div className="ace-production">
                <div className="ace-production-image" aria-hidden="true">
                    {
                        props.production.pdpImageSrc ?
                            <img src={props.production.pdpImageSrc} className="" alt="" />
                            : null
                    }

                </div>
                <div className="ace-production-content stack-lg">
                    <div className="ace-production-heading stack-sm">
                        {
                            pdpHeader
                        }
                        <p className="h2-secondary">
                            {props.production.dateRangeString}
                        </p>
                        {
                            props.production.facility != null ?
                                <p className="h3-secondary">
                                    {
                                        props.production.facility.facilityImageUrl != null ?
                                            <a target="_blank" href={props.production.facility.facilityImageUrl}>{props.production.facility.facilityDescription}</a>
                                            :
                                            props.production.facility.facilityDescription
                                    }

                                </p>

                                : null
                        }
                    </div>
                    <div className="ace-production-ctas spaced-list">
                        <p className="ace-production-ctas-primary">
                            <button className={`un-button primary-link dropdown-trigger ${props.showPerformances ? 'dropdown-trigger-up' : 'dropdown-trigger-down'}`} onClick={props.toggleShowPerformances}>
                                {
                                    props.showPerformances ? props.text.hidePerformancesButtonText
                                        : props.text.viewPerformancesButtonText
                                }
                            </button>
                        </p>
                    </div>
                </div>
            </div>
            <div className={props.showPerformances ? "show" : "hide"} >
                <div className="ace-production stack">
                    <div className="ace-production-placeholder">
                        {props.production.productionSynopsis ?
                            <div className="rich-text small space-top-lg">
                                <h4>{props.text.synopsisHeaderLabel}</h4>
                                <p>{props.production.productionSynopsis}</p>
                            </div>
                            : null
                        }
                    </div>
                    <div className="ace-production-content stack">
                        <ListPerformances filteredPerformances={props.filteredPerformances} />
                    </div>
                </div>
            </div>
        </li>
    );
}

export default ListMonthsView;